import { useSharedTranslation } from "#hooks/useSharedTranslation.ts";
import { Flex, Spinner } from "@hopper-ui/components";

export const PageLoading = () => {
    const { tShared } = useSharedTranslation();

    return (
        <Flex justifyContent="center" alignItems="center" height="100%">
            <Spinner aria-label={tShared("loading")}></Spinner>
        </Flex>
    );
};
